import React, { useState, useEffect } from "react";
import {
    Form,
    Input,
    FormInstance,
    Cascader,
    TreeSelect,
    Spin,
    Space,
    Button,
    Row,
    Col,
    Upload,
    notification, Select, Table, InputNumber, Radio, Tooltip, Tag, Empty
} from "antd";
import { InfoCircleOutlined,PlusOutlined} from '@ant-design/icons';
import {
    getWebfilter, addWebfilter, deleteWebfilter, getAndroidWebfilter, addAndroidWebfilter, deleteAndroidWebfilter
} from "../../../axios/api.device"
import { gaEvent } from "../../../withTracker"

import { useTranslation } from "react-i18next";
import i18n from "@src/locales";

const { Column } = Table;
const { Item } = Form;
interface propsModel {
    templateId: string,
    platform: string,
    templateTab: any,
    updateTemplate: () => void,
}

export const TemplateContentBrowse = (props: propsModel) => {
    const { templateId, platform, templateTab, updateTemplate } = props;
    const [showTable, setShowTable] = useState<number>(0);
    const [selectKey, setSelectKey] = useState<string>("white");
    const [permittedURLs, setPermittedURLs] = useState<any[]>([]);
    const [allowListBookmarks, setAllowListBookmarks] = useState<any[]>([]);
    const [denyListURLs, setDenyListURLs] = useState<any[]>([]);
    const [currentUrl, setCurrentUrl] = useState<string>("");
    const [title, setTitle] = useState<string>("");
    const [autoFilterEnabled, setAutoFilterEnabled] = useState<boolean>(true);

    const { t } = useTranslation();

    var addClick = () => {
        setShowTable(2)
    }
    useEffect(() => {
        getDataInfo();
    }, [])
    const selectBefore = (
        <Select disabled defaultValue="https://" className="select-before">
            <Select.Option value="https://">https://</Select.Option>
        </Select>
    );
    const getDataInfo = () => {
        if (platform == "Android") {
            getAndroidWebfilter(templateId).then((res) => {
                if (res && res != null) {
                    setPermittedURLs(getObjs(res.permittedURLs));
                    setDenyListURLs(getObjs(res.denyListURLs));
                    setAutoFilterEnabled(res.autoFilterEnabled);
                    setShowTable(2)
                    if (res.denyListURLs && res.denyListURLs.length > 0) {
                        setSelectKey("black")
                    } else {
                        setSelectKey("white")
                    }
                } else {
                    setShowTable(1)
                }
            })
        } else {
            getWebfilter(templateId).then((res) => {
                if (res && res != null) {
                    if (res.permittedURLs) {
                        setPermittedURLs(res.permittedURLs);
                    }
                    if (res.allowListBookmarks) {
                        setAllowListBookmarks(res.allowListBookmarks);
                    }
                    // setPermittedURLs(getObjs(res.permittedURLs));
                    setDenyListURLs(getObjs(res.denyListURLs));
                    setAutoFilterEnabled(res.autoFilterEnabled);
                    setShowTable(2);
                    if (res.denyListURLs && res.denyListURLs.length > 0) {
                        setSelectKey("black");
                    } else {
                        setSelectKey("white");
                    }
                } else {
                    setShowTable(1)
                }
            })
        }

    }
    const addTemplateClick = () => {
        if (platform == "Android") {
            var res: any = {};
            res.autoFilterEnabled = autoFilterEnabled;
            if (selectKey == "white") {
                res.permittedURLs = getUrls(permittedURLs);
                res.denyListURLs = [];
            } else {
                res.permittedURLs = [];
                res.denyListURLs = getUrls(denyListURLs);
            }
            addAndroidWebfilter(templateId, res).then(() => {
                updateTemplate();
                notification.success({ message: t("成功") });
                getDataInfo();
            })
        } else {
            var res: any = {};
            res.autoFilterEnabled = autoFilterEnabled;
            if (selectKey == "white") {
                // res.permittedURLs = getUrls(permittedURLs);
                res.allowListBookmarks = allowListBookmarks;
                res.denyListURLs = [];
            } else {
                res.permittedURLs = [];
                res.denyListURLs = getUrls(denyListURLs);
            }
            addWebfilter(templateId, res).then(() => {
                updateTemplate();
                notification.success({ message: t("成功") });
                getDataInfo();
            })
        }


    }
    const getUrls = (arr: any[]) => {
        var strs: string[] = [];
        arr.forEach((ele: any) => {
            strs.push(ele.address);
        });
        return strs;
    }
    const getObjs = (arr: any[]) => {
        if (!arr) {
            return [];
        }
        var strs: any[] = [];
        arr.forEach((ele: any) => {
            strs.push({ address: ele });
        });
        return strs

    }
    const deleteTemplateClick = () => {
        if (platform == "Android") {
            deleteAndroidWebfilter(templateId).then(() => {
                setSelectKey("white");
                setPermittedURLs([]);
                setAllowListBookmarks([]);
                setDenyListURLs([]);
                updateTemplate();
                notification.success({ message: t("成功") });
                getDataInfo();
            })
        } else {
            deleteWebfilter(templateId).then(() => {
                setSelectKey("white");
                setPermittedURLs([]);
                setAllowListBookmarks([]);
                setDenyListURLs([]);
                updateTemplate();
                notification.success({ message: t("成功") });
                getDataInfo();
            })
        }
    }
    const addUrl = () => {
        if (!currentUrl) {
            notification.warning({message: t("链接地址不能为空")})
            return
        }
        if (selectKey == "white") {
            if (platform !== "Android") {
                allowListBookmarks.push({title: title, url: currentUrl});
                setAllowListBookmarks([...allowListBookmarks]);
                setTitle("");
            } else {
                permittedURLs.push({ address: currentUrl });
                setPermittedURLs([...permittedURLs]);
            }
        } else {
            denyListURLs.push({ 
                address: platform === "macOS" ? (
                    currentUrl.includes("https://") ? currentUrl : `https://${currentUrl}`
                ) : currentUrl 
            })
            setDenyListURLs([...denyListURLs]);
        }
        setCurrentUrl("");

    }
    const removeUrl = (index: number) => {
        if (selectKey == "white") {
            if (platform === "Android") {
                permittedURLs.splice(index, 1)
                setPermittedURLs([...permittedURLs]);
            } else {
                allowListBookmarks.splice(index, 1);
                setAllowListBookmarks([...allowListBookmarks]);
            }
        } else {
            denyListURLs.splice(index, 1)
            setDenyListURLs([...denyListURLs]);
        }
    }
    return (<>
        <div>
            <Row style={{ margin: "32px 16px 8px 50px", fontSize: "16px" }}>
                <Col className="templateTitle">{t("网页浏览规则")}</Col>
                {platform != "Android" && (
                    <Col style={{ marginLeft: 36 }}>
                        {templateTab?.availabilities.map((c: any) => (
                            <Tooltip title={
                                i18n.language === "zh" ? `只能在${c}以上的设备上才能配置` : 
                                i18n.language === "en" ? `Only be configured on devices above iOS ${c}` : ""
                            }>
                                <Tag color="cyan">{c}</Tag>
                            </Tooltip >
                        ))}
                        {templateTab?.supervisedRequired && (
                            <Tooltip title={t("只适用于受监督设备")}>
                                <Tag color="purple">S</Tag>
                            </Tooltip>
                        )}
                    </Col>
                )}
            </Row>
            <Row><div className="dividerStyle"></div></Row>
            <Row style={{ margin: "16px 16px 16px 0px" }}>
                {showTable == 1 && (
                    <div>
                        <p style={{ margin: "32px 16px 8px 50px", fontSize: "14px" }}>
                        {platform  =="Android"?t("设置网页浏览规则,安卓系统只能够针对chrome浏览器限制,设置后会自动安装chrome浏览器,隐藏自带浏览器"):t("设置网页浏览规则")} </p>
                        <div style={{ margin: "32px 16px 8px 50px", fontSize: "16px" }}>
                        <Button onClick={() => { addClick(); gaEvent("templateContentPassword", "onClick", "addClick") }} type="primary">
                                <PlusOutlined /> {t("添加规则")}
                            </Button>
                        </div>
                    </div>
                    // <>
                    //     <Row style={{ margin: "8px 16px 16px 50px", fontSize: "14px" }}>
                    //         {platform  =="Android"?"设置网页浏览规则，安卓系统只能够针对chrome浏览器限制，设置后会自动安装chrome浏览器，隐藏自带浏览器":"设置网页浏览规则"} 
                    //     </Row>
                    //     <Row style={{ margin: "100px 16px 16px 50px", fontSize: "16px" }}>
                    //         <Button onClick={() => { addClick(); gaEvent("templateContentPassword", "onClick", "addClick") }} type="primary">
                    //             添加规则
                    //         </Button>
                    //     </Row>
                    // </>
                )}
                {showTable == 2 && (
                    <>
                        <Row style={{ width: "100%", margin: 10 }}>
                            <Col span={4}>{t("浏览设置")}</Col>
                            <Col span={4}>
                                <Radio.Group buttonStyle="solid" value={selectKey} onChange={(e) => { setSelectKey(e.target.value) }} >
                                    <Radio.Button value="white">{t("白名单")}</Radio.Button>
                                    <Radio.Button value="black">{t("黑名单")}</Radio.Button>
                                </Radio.Group>
                            </Col>
                            <Col span={4} style={{ color: "gray" }}><InfoCircleOutlined />&nbsp;&nbsp;&nbsp;{selectKey == "white" ? t("只能访问允许的地址") : t("拦截的链接无法访问")}</Col>
                        </Row>
                        <Row style={{ width: "100%", margin: 16 }}>
                            <Col span={24}>{selectKey == "white" ? t("允许的链接") : t("拦截的链接")}</Col>
                        </Row>
                        <Row style={{ width: "100%", marginLeft: 36 }}>

                            <Row style={{ width: "100%", marginLeft: 36 }}>
                                <Col span={16}>
                                    <Table 
                                        dataSource={selectKey === "white" ? (platform === "Android" ? permittedURLs : allowListBookmarks) : denyListURLs} 
                                        locale={{emptyText: <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description={t("暂无数据")}></Empty>}}
                                        pagination={false}
                                    >
                                        {(platform === "Android" || selectKey === "black") && <Column title={t("链接地址")} key="address" dataIndex="address"></Column>}
                                        {(platform !== "Android" && selectKey === "white") && (
                                            <>
                                                <Column title={t("链接地址")} key="url" dataIndex="url"></Column>
                                                <Column title={t("名称")} key="title" dataIndex="title"></Column>
                                            </>
                                        )}
                                        {/* <Column title="备注" key="remark" dataIndex="remark"></Column> */}
                                        <Column title={t("操作")} key="id" dataIndex="id" render={(v, row: any, index: any) => {
                                            return (
                                                <>
                                                    <Button key={index} onClick={(e) => { removeUrl(index) }} type="primary" ghost size="small">
                                                        {t("删除")}
                                                    </Button>
                                                </>
                                            );
                                        }}></Column>
                                    </Table>
                                </Col>
                            </Row>
                            <Row style={{ width: "100%", marginLeft: 36, marginTop: 10 }}>
                                {(platform === "Android" || selectKey === "black") && 
                                    <Col span={14}>
                                        <Input value={currentUrl} onChange={(e) => { setCurrentUrl(e.target.value) }} addonBefore={selectBefore} />
                                    </Col>
                                }
                                {(platform !== "Android" && selectKey === "white") && (
                                    <>
                                        <Col span={8}>
                                            <Input value={currentUrl} onChange={(e) => { setCurrentUrl(e.target.value) }} addonBefore={t("链接地址")} />
                                        </Col>
                                        <Col span={6}>
                                            <Input value={title} onChange={(e) => { setTitle(e.target.value) }} addonBefore={t("名称")} />
                                        </Col>
                                    </>
                                )}
                                <Col style={{ textAlign: "center", lineHeight: "32px" }} span={2}>
                                    <Button type="primary" ghost size="small" onClick={(e) => { addUrl() }}>{t("添加")}</Button>
                                </Col>

                            </Row>

                        </Row>
                        {selectKey == "black" && (

                            <Row style={{ width: "100%", margin: 10 }}>
                                <Col span={4}>{t("自动限制不安全的内容")}</Col>
                                <Col>
                                    <Radio.Group value={autoFilterEnabled} onChange={(e) => { setAutoFilterEnabled(e.target.value) }} >
                                        <Radio value={true}>{t("是")}</Radio>
                                        <Radio value={false}>{t("否")}</Radio>
                                    </Radio.Group>
                                </Col>
                                <Col span={8} style={{ color: "gray" }}><InfoCircleOutlined />&nbsp;&nbsp;&nbsp;{t("无法访问浏览器默认的不安全内容")}</Col>
                            </Row>
                        )}

                        <div style={{ margin: "32px 16px 8px 50px", fontSize: "20px", textAlign: "center", width: "100%" }}>
                            <Button style={{ width: 100 }} type="primary" onClick={() => { addTemplateClick(); gaEvent("templateContentPassword", "onClick", "addTemplateClick") }}> {t("保存")} </Button>
                            <Button style={{ width: 100, marginLeft: 20 }} type="primary" ghost onClick={() => { deleteTemplateClick(); gaEvent("templateContentPassword", "onClick", "deleteTemplateClick") }}>{t("删除规则")}</Button>
                        </div>
                    </>
                )}
            </Row>
        </div>

    </>)
};